var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

import PropTypes from 'prop-types';

var LayoutRow = function (_React$Component) {
  _inherits(LayoutRow, _React$Component);

  function LayoutRow() {
    _classCallCheck(this, LayoutRow);

    return _possibleConstructorReturn(this, (LayoutRow.__proto__ || Object.getPrototypeOf(LayoutRow)).apply(this, arguments));
  }

  _createClass(LayoutRow, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'cf-layout__row' },
        this.props.children
      );
    }
  }]);

  return LayoutRow;
}(React.Component);

LayoutRow.propTypes = {
  children: PropTypes.node
};

export default LayoutRow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-layout/es/LayoutRow.js
// module id = 638
// module chunks = 0